export default __webpack_public_path__ + "static/media/discord.9916c486.svg";